/* HKK homepage hero (HKK Tasks #17): the gift box fills with real products on a loop. Items come from the
   section's JSON (packed dimensions plus the BYO photo rule: upright cut-out, then flat cut-out, then the
   product photo as a tile). Geometry, packing and drawing are the BYO Gift Set's (assets/hkk-byo.js, the hand-packed
   look of 2026-10-27): the box is packed once, biggest first, and items drop in from the bottom of the pile up.
   shortcut: the packing and drawing are copied from hkk-byo.js, move them to a shared file if either one changes. */
(function () {
  'use strict';
  const root = document.querySelector('[data-hkk-home-hero]');
  if (!root) return;
  const $ = (sel) => root.querySelector(sel);
  let ITEMS = [];
  try { ITEMS = JSON.parse($('[data-items]').textContent).filter((it) => it.image || it.flat || it.upright); } catch (e) { return; }

  const BOX_L = 42, BOX_W = 34, BOX_H = 25;
  const PHOTO_CROP = { x: 100, y: 36, w: 730, h: 580 };
  const FLOOR = { x: 273, y: 180, w: 416, h: 316 };
  const PXX = FLOOR.w / BOX_L, PXY = FLOOR.h / BOX_W;
  const PARCEL_CM = { x: 32, y: 25, w: 10, h: 9 };
  ITEMS.forEach((it) => { // a cut-out photo must lie the way it was shot (as in hkk-byo.js)
    if (!it.upright && !it.flat) return;
    const d = [...it.cm].sort((x, y) => y - x);
    it.across = it.ua >= 1 ? [d[0], d[1]] : [d[1], d[0]];
    if (it.across[0] > BOX_L || it.across[1] > BOX_W) { it.upright = ''; it.flat = ''; it.across = null; }
  });
  const SHADOW_OFFSET = 0.9, SHADOW_BLUR = 1.6, GROW_PER_10CM = 0.03, RISE_SCALE = 0.5, STAGE_PERSPECTIVE_PX = 1000; // the stage's CSS perspective
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const PAPER_PALETTE = [['#ecceba', 30], ['#f3d9c7', 25], ['#e3c3ab', 25], ['#d8b59b', 10], ['#fae3d3', 10]];
  const PAPER_WEIGHT = PAPER_PALETTE.reduce((n, p) => n + p[1], 0);
  function makeRnd(seed) { let s = seed | 0; return () => { s = (s + 0x6D2B79F5) | 0; let t = Math.imul(s ^ (s >>> 15), 1 | s); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; }; }
  function pickPaper(rnd) { let r = rnd() * PAPER_WEIGHT; for (const [col, w] of PAPER_PALETTE) { if ((r -= w) <= 0) return col; } return PAPER_PALETTE[0][0]; }
  function strand(ctx, rnd, x, y, a, len, segs, wobble) {
    let px = x, py = y;
    const path = new Path2D(); path.moveTo(px, py);
    for (let seg = 0; seg < segs; seg++) {
      a += (rnd() - 0.5) * 1.6;
      const nx = px + Math.cos(a) * len / segs, ny = py + Math.sin(a) * len / segs;
      path.quadraticCurveTo((px + nx) / 2 + (rnd() - 0.5) * wobble, (py + ny) / 2 + (rnd() - 0.5) * wobble, nx, ny);
      px = nx; py = ny;
    }
    ctx.lineWidth = 1.7 + rnd() * 1.8;
    ctx.save(); ctx.translate(0.8, 1.2); ctx.strokeStyle = 'rgba(70,45,20,.14)'; ctx.stroke(path); ctx.restore();
    ctx.strokeStyle = pickPaper(rnd); ctx.stroke(path);
  }
  function drawShred(canvas, w, h, seed) {
    const OUTB = 20, OUTS = 13, OUTT = 8, dpr = 1.5; // the paper gathers at the front, so that side gets the margin
    const W = Math.ceil(w + 2 * OUTS), H = Math.ceil(h + OUTB + OUTT), ox = OUTS, oy = OUTT;
    canvas.width = W * dpr; canvas.height = H * dpr;
    canvas.style.cssText = 'left:' + (-ox) + 'px;top:' + (-oy) + 'px;width:' + W + 'px;height:' + H + 'px';
    const ctx = canvas.getContext('2d'), rnd = makeRnd(seed * 7919 + 11);
    ctx.scale(dpr, dpr); ctx.lineCap = 'round'; ctx.lineJoin = 'round';
    // a soft mound of paper bunched against the front edge, so the item reads as settled into the bed
    const mound = ctx.createLinearGradient(0, oy + h - 4, 0, oy + h + OUTB);
    mound.addColorStop(0, 'rgba(240,214,190,0)');
    mound.addColorStop(0.45, 'rgba(239,211,185,.5)');
    mound.addColorStop(1, 'rgba(239,211,185,0)');
    ctx.fillStyle = mound; ctx.fillRect(ox - 6, oy + h - 4, w + 12, OUTB + 4);
    // a loose fan of strands along the front, a few tips curling back over the item's edge
    const n = Math.max(5, Math.round(w / 15));
    for (let i = 0; i < n; i++) {
      const x = ox + ((i + 0.2 + rnd() * 0.6) / n) * w, y = oy + h - 2 + rnd() * 4;
      strand(ctx, rnd, x, y, Math.PI / 2 + (rnd() - 0.5) * 1.1, 13 + rnd() * 16, 3, 6);
      if (rnd() < 0.55) strand(ctx, rnd, x + (rnd() - 0.5) * 8, y - rnd() * 3, -Math.PI / 2 + (rnd() - 0.5) * 0.7, 5 + rnd() * 8, 2, 4);
    }
    // a couple of tucks low on each side, where a hand would fold the paper in
    for (let i = 0, ns = Math.max(2, Math.round(h / 26)); i < ns; i++) {
      const y = oy + h * (0.58 + 0.38 * rnd());
      strand(ctx, rnd, ox - 1 + rnd() * 2, y, Math.PI + (rnd() - 0.5) * 0.8, 7 + rnd() * 8, 3, 5);
      strand(ctx, rnd, ox + w + 1 - rnd() * 2, y, (rnd() - 0.5) * 0.8, 7 + rnd() * 8, 3, 5);
    }
  }

  /* Packing: the BYO Gift Set's hand-packed pile (a height in cm per item), packed once, biggest first */
  function footprint(cm) { const d = [...cm].sort((a, b) => b - a); return { a: d[0], b: d[1], t: d[2] }; }
  const PARCEL_REST = Object.assign({ t: 99, z: 0 }, PARCEL_CM); // nothing rests on the mystery gift
  const inter = (r, o) => Math.max(0, Math.min(r.x + r.w, o.x + o.w) - Math.max(r.x, o.x)) * Math.max(0, Math.min(r.y + r.h, o.y + o.h) - Math.max(r.y, o.y));
  function rest(r, placed, cov) { // the height r would rest at, how much of it is held there, and the most of one item it would leave hidden
    let z = 0, held = 0, buries = 0;
    placed.forEach((o) => { if (inter(r, o) > 0.25) z = Math.max(z, o.z + o.t); });
    placed.forEach((o) => {
      const a = inter(r, o); if (a <= 0.25) return;
      if (o.z + o.t >= z - 1) held += a;
      buries = Math.max(buries, (a + (cov ? cov.get(o) || 0 : 0)) / (o.w * o.h)); // with what already lies on it
    });
    return { z, held: z === 0 ? 1 : held / (r.w * r.h), buries };
  }
  function scoreSpot(r, at, hN, uid, i, placed) {
    const wantY = 0.6 + (BOX_W - 1.2 - r.h) * (1 - hN);   // tall or standing at the back, low or flat at the front
    let s = Math.abs(r.y - wantY) / BOX_W * 1.2;
    s += Math.abs(r.x + r.w / 2 - BOX_L / 2) / BOX_L * 0.55; // gather around the middle of the bed
    if (at.z > 0) s += 0.6 + at.z * 0.06 + at.buries * 0.8; // free paper first, then the lowest part of the pile, covering little
    else if (placed.length > 1) {
      let touching = false;
      for (const o of placed) {
        const gx = Math.max(0, o.x - (r.x + r.w), r.x - (o.x + o.w)), gy = Math.max(0, o.y - (r.y + r.h), r.y - (o.y + o.h));
        if (o.z === 0 && gx + gy < 1.6) { touching = true; break; } // a hand tucks the new item against the ones already in
      }
      s += touching ? -0.14 : 0.25;
    }
    return s + seeded(uid * 41 + i) * 0.02;                 // deterministic tie-break: same box, same picture
  }
  function findSpot(placed, a, b, fixed, uid, hN, t) {
    const orients = fixed ? [[a, b]] : [[a, b], [b, a]];
    const jx = (seeded(uid * 17 + 5) - 0.5) * 2.2, jy = (seeded(uid * 29 + 7) - 0.5) * 1.6; // hand-placed offset, per unit
    const cand = [], seen = new Set();
    const push = (x, y, w, h, jit) => {
      if (jit) { x += jx; y += jy; }
      x = Math.round(Math.min(Math.max(x, 0), BOX_L - w) * 4) / 4; y = Math.round(Math.min(Math.max(y, 0), BOX_W - h) * 4) / 4;
      const k = x + ',' + y + ',' + w;
      if (!seen.has(k)) { seen.add(k); cand.push({ x, y, w, h }); }
    };
    orients.forEach(([w, h]) => {
      if (w > BOX_L || h > BOX_W) return;
      placed.forEach((o) => { // the natural tuck points around each item already packed, and on top of it
        push(o.x - w - 0.5, o.y, w, h, 1); push(o.x - w - 0.5, o.y + o.h - h, w, h, 1);
        push(o.x + o.w + 0.5, o.y, w, h, 1); push(o.x + o.w + 0.5, o.y + o.h - h, w, h, 1);
        push(o.x, o.y - h - 0.5, w, h, 1); push(o.x + o.w - w, o.y - h - 0.5, w, h, 1);
        push(o.x, o.y + o.h + 0.5, w, h, 1); push(o.x + o.w - w, o.y + o.h + 0.5, w, h, 1);
        push(o.x + (o.w - w) / 2, o.y + (o.h - h) / 2, w, h, 1);
      });
      push((BOX_L - w) / 2, (BOX_W - h) / 2, w, h, 1); push((BOX_L - w) / 2, 1, w, h, 1); push((BOX_L - w) / 2, BOX_W - h - 1, w, h, 1);
      for (let y = 0; y <= BOX_W - h; y += 3) for (let x = 0; x <= BOX_L - w; x += 3) push(x, y, w, h, 0); // a coarse sweep, so a spot always exists
    });
    let best = null, bestS = Infinity, hides = null, hidesS = Infinity, over = null, overS = Infinity;
    const cov = new Map(placed.map((o) => [o, placed.reduce((n, q) => (q !== o && q.z > o.z ? n + inter(q, o) : n), 0)])); // area already on top of each item
    cand.forEach((r, i) => {
      const at = rest(r, placed, cov);
      if (at.z >= 99 || at.held < 0.3) return;                // never on the mystery gift, never hanging in the air
      const s = scoreSpot(r, at, hN, uid, i, placed), spot = Object.assign(r, { t, z: at.z });
      if (at.z + t > BOX_H + 3) { if (!over || at.z < over.z || (at.z === over.z && s < overS)) { overS = s; over = spot; } } // a full box: the lowest spot
      else if (at.buries > 0.7) { const hs = Math.round(at.buries * 10) + s / 10; if (hs < hidesS) { hidesS = hs; hides = spot; } } // would hide most of an item below: only if nothing else fits, and then the spot that hides least
      else if (s < bestS) { bestS = s; best = spot; }         // a proper nook, every item below stays partly visible
    });
    if (best) best.ok = true; // `hides` and `over` are a full box's best effort, and trigger one repack
    return best || hides || over;
  }
  function packAll() {
    const placed = [PARCEL_REST], out = [];
    const order = ITEMS.map((it, i) => i).sort((p, q) => { const A = footprint(ITEMS[p].cm), B = footprint(ITEMS[q].cm); return (B.a * B.b - A.a * A.b) || (p - q); });
    order.forEach((i) => {
      const it = ITEMS[i], f = footprint(it.cm), [a, b] = it.across || [f.a, f.b];
      const hN = it.upright ? 1 : it.flat ? 0 : Math.min(1, f.t / 16); // depth preference from standing height
      const p = findSpot(placed, a, b, !!it.across, i + 1, hN, f.t) || { x: (BOX_L - a) / 2, y: (BOX_W - b) / 2, w: a, h: b, t: f.t, z: 0 };
      out[i] = p; placed.push(p);
    });
    return out;
  }
  const seeded = (n) => { let t = (n * 2654435761) >>> 0; t ^= t >>> 15; t = Math.imul(t, 2246822519); t ^= t >>> 13; return (t >>> 0) / 4294967296; };
  const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const stage = $('[data-stage]'), scene = $('[data-scene]'), home = $('[data-stagehome]');
  function makeTile(it, p, i) {
    const el = document.createElement('div'), upright = !!it.upright, flat = !!it.flat, uid = i + 1;
    const tilt = upright ? 0 : (seeded(uid * 3 + 1) - 0.5) * (flat ? 6 : 9); // small hand-placed rotation; an upright cut-out keeps its footing
    // resting on other items: raised in the 3D scene at half height, without the perspective's magnification (as in hkk-byo.js)
    const hcm = footprint(it.cm).t, rise = p.z * PXX * RISE_SCALE, unzoom = 1 - rise * 0.94 / STAGE_PERSPECTIVE_PX;
    const grow = (upright ? 1 : 1 + GROW_PER_10CM * hcm / 10) * unzoom;
    const w = p.w * PXX, h = p.h * PXY;
    el.className = 'hkk-h__tile' + (upright ? ' hkk-h__tile--upright' : flat ? ' hkk-h__tile--flat' : p.w / p.h > 2 ? ' hkk-h__tile--slim' : '');
    el.title = it.name;
    el.innerHTML = '<i class="hkk-h__bed"></i><div class="hkk-h__tile-inner"><img alt="" src="' + esc(it.upright || it.flat || it.image) + '"></div><canvas class="hkk-h__shred"></canvas><i class="hkk-h__puff"></i>';
    el.style.cssText = 'left:' + (FLOOR.x - PHOTO_CROP.x + p.x * PXX) + 'px;top:' + (FLOOR.y - PHOTO_CROP.y + p.y * PXY) + 'px;width:' + w + 'px;height:' + h + 'px;'
      + 'transform:translateZ(' + rise.toFixed(1) + 'px) rotate(' + tilt.toFixed(1) + 'deg) scale(' + grow.toFixed(3) + ');'
      + 'z-index:' + (10 + Math.round(p.z) * 40 + Math.round(p.y + p.h)) + ';--sh-y:' + (hcm * SHADOW_OFFSET).toFixed(1) + 'px;--sh-b:' + (hcm * SHADOW_BLUR).toFixed(1) + 'px';
    drawShred(el.querySelector('.hkk-h__shred'), w, h, uid);
    return el;
  }
  function fitStage() { const k = home.clientWidth / PHOTO_CROP.w; if (k > 0) stage.style.transform = 'scale(' + k + ')'; }
  new ResizeObserver(fitStage).observe(home);
  stage.appendChild(document.createElement('div')).className = 'hkk-h__light'; // one shared light over photo and items, outside the 3D scene

  const parcel = $('[data-parcel]');
  parcel.appendChild(document.createElement('canvas')).className = 'hkk-h__shred';
  drawShred(parcel.lastChild, PARCEL_CM.w * PXX, PARCEL_CM.h * PXY, 4242);
  const placed = packAll();
  console.assert(placed.length === ITEMS.length && placed.every((p) => p && p.z < 99), 'hkk-home: packing drifted', placed);
  // drop order: the bottom of the pile first, then back to front, so each item lands on what is already there
  const tiles = placed.map((p, i) => ({ p, i })).sort((a, b) => (a.p.z - b.p.z) || (a.p.y - b.p.y))
    .map(({ p, i }) => { const el = makeTile(ITEMS[i], p, i); el.hidden = true; scene.appendChild(el); return el; });

  /* The loop: items drop in one by one, the full box rests, everything lifts out, and it starts again */
  const DROP_EVERY = 240, REST = 2800, LIFT = 500, EMPTY = 700;
  function show(el) {
    el.classList.remove('is-lift'); el.hidden = false; el.classList.add('is-drop');
    el.querySelector('.hkk-h__tile-inner').addEventListener('animationend', () => el.classList.remove('is-drop'), { once: true });
    scene.classList.remove('is-thud'); void scene.offsetWidth; scene.classList.add('is-thud');
  }
  function loop() {
    tiles.forEach((el, i) => setTimeout(() => show(el), 400 + i * DROP_EVERY));
    const full = 400 + tiles.length * DROP_EVERY + 600;
    setTimeout(() => tiles.forEach((el) => el.classList.add('is-lift')), full + REST);
    setTimeout(() => tiles.forEach((el) => { el.hidden = true; el.classList.remove('is-lift', 'is-drop'); }), full + REST + LIFT);
    setTimeout(loop, full + REST + LIFT + EMPTY);
  }
  if (reduceMotion.matches || !tiles.length) tiles.forEach((el) => { el.hidden = false; }); else loop();
  fitStage();
})();
